<template>
  <div
    v-loading="loading"
    class="main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div style="display: flex;height: 100%;">
      <div class="section" style="width: 280px;margin-bottom: 0;">
        <span class="title">{{ $t('CargoMsg.Cargo_ResponsibilityList') }}</span>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div style="flex-grow: 1;margin-left: 10px;">
        <div class="section operations">
          <div class="triggers">
            <div>
              <el-button
                v-permission="['button_OperationResponsibility_add']"
                type="primary"
                @click="addHandler"
              >{{ $t('CargoMsg.Cargo_New') }}</el-button>
              <el-button
                v-permission="['button_OperationResponsibility_edit']"
                :disabled="!selectedNode"
                type="primary"
                @click="editHandler"
              >{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
              <el-button
                v-permission="['button_OperationResponsibility_delete']"
                :disabled="!selectedNode"
                type="primary"
                @click="delHandler"
              >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            </div>
          </div>
        </div>
        <div class="section" style="height: 100%;">
          <span class="title">{{ $t('CargoMsg.Cargo_ResponsibilityInformation') }}</span>
          <el-form label-width="100px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_Name')+':'">{{ form.name }}</el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')+':'">{{ form.englishName }}</el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Airline')+':'">{{ form.airRoute.name || '' }}</el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AirlineCompany')+':'">{{ form.airCmp.chineseName || '' }}</el-form-item>
            <el-form-item :label="$t('SeaExport.BookingProperty')+':'">{{ form.bookingTerm.chineseName || '' }}</el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Airport')+':'">{{ form.airPort.chineseName || '' }}</el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Sales')+':'">{{ form.sales.chineseName || form.sales.englishName || '' }}</el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="responsibilityDialog.visible"
      :title="responsibilityDialog.title"
      :width="$selectByLang('430px', '470px')"
      :close-on-click-modal="false"
      class="responsibility-dialog"
    >
      <!-- 步骤1 -->
      <div v-show="responsibilityDialog.stepNo===1" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep1') }}</div>
        <el-form :label-width="$selectByLang('60px', '100px')" label-position="left" style="margin: 50px 0 30px 30px;">
          <el-form-item :label="$t('CargoMsg.Cargo_Name')+':'">
            <el-input v-model="responsibilityDialog.form.name" placeholder=" " style="width: 300px;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')+':'">
            <el-input v-model="responsibilityDialog.form.englishName" placeholder=" " style="width: 300px;" />
          </el-form-item>
        </el-form>
      </div>
      <!-- 步骤2 -->
      <div v-show="responsibilityDialog.stepNo===2" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep2') }}</div>
        <el-form label-width="50px" label-position="right" style="margin: 50px 0 30px 30px;">
          <el-form-item :label="$t('CargoMsg.Cargo_Airline')+':'">
            <cargo-advance-select
              :select-type="TYPE_NAMES.static_data_AirRoute"
              :cache="false"
              :static-options="airRouteList"
              filterable
              :default-value="responsibilityDialog.form.airRoute.code||''"
              placeholder=" "
              style="width: 300px;"
              @parentCallBack="p=>{responsibilityDialog.form.airRoute=p}"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 步骤3 -->
      <div v-show="responsibilityDialog.stepNo===3" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep3') }}</div>
        <el-form :label-width="$selectByLang('70px', '110px')" label-position="right" style="margin: 50px 0 30px 30px;">
          <el-form-item :label="$t('SeaExport.AirlineCompany')+':'">
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{airCmp:true}"
              filterable
              :default-value="responsibilityDialog.form.airCmp.cmpIdx||''"
              placeholder=" "
              style="width: 280px;"
              @parentCallBack="p=>{responsibilityDialog.form.airCmp=p}"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 步骤4 -->
      <div v-show="responsibilityDialog.stepNo===4" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep4') }}</div>
        <el-form :label-width="$selectByLang('70px', '110px')" label-position="right" style="margin: 50px 0 30px 30px;">
          <el-form-item :label="$t('SeaExport.BookingProperty')+':'">
            <el-select
              :value="responsibilityDialog.form.bookingTerm.code||''"
              :placeholder="$t('SeaExport.PleaseSelect')"
              :clearable="true"
              size="mini"
              style="width: 150px;"
              @input="value=>{responsibilityDialog.form.bookingTerm=BookingTerm.getBookingTypeByCode(value)||{}}"
            >
              <el-option v-for="(item,index) in BookingTerm.BOOKING_TERMS" :key="index" :label="item.chineseName" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- 步骤5 -->
      <div v-show="responsibilityDialog.stepNo===5" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep5') }}</div>
        <el-form label-width="60px" label-position="right" style="margin: 50px 0 30px 30px;">
          <el-form-item :label="$t('CargoMsg.Cargo_Airport')+':'">
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Airport"
              filterable
              :default-value="responsibilityDialog.form.airPort.code||''"
              placeholder=" "
              style="width: 300px;"
              @parentCallBack="p=>{responsibilityDialog.form.airPort=p}"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 步骤6 -->
      <div v-show="responsibilityDialog.stepNo===6" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep6') }}</div>
        <el-form label-width="60px" label-position="right" style="margin: 50px 0 30px 30px;">
          <el-form-item :label="$t('CargoMsg.Cargo_Sales')+':'">
            <cargo-user-select
              :method-params="{category:'role',shape:'sales'}"
              :show-custom-label-in-option="true"
              :custom-label="userLabel"
              :default-value="responsibilityDialog.form.sales.userId||''"
              style="width: 200px;"
              @change="p=>{responsibilityDialog.form.sales=p}"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 步骤7 -->
      <div v-show="responsibilityDialog.stepNo===7" class="step">
        <div class="step-title">{{ $t('CargoMsg.Cargo_ResponsibilityStep7') }}</div>
        <el-form :label-width="$selectByLang('100px', '120px')" label-position="right" style="margin-top: 10px;">
          <el-form-item :label="$t('CargoMsg.Cargo_Name')+':'">{{ responsibilityDialog.form.name }}</el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')+':'">{{ responsibilityDialog.form.englishName }}</el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Airline')+':'">{{ responsibilityDialog.form.airRoute.name || '' }}</el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCompany')+':'">{{ responsibilityDialog.form.airCmp.chineseName || '' }}</el-form-item>
          <el-form-item :label="$t('SeaExport.BookingProperty')+':'">{{ responsibilityDialog.form.bookingTerm.chineseName || '' }}</el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Airport')+':'">{{ responsibilityDialog.form.airPort.chineseName || '' }}</el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Sales')+':'">{{ responsibilityDialog.form.sales.chineseName || responsibilityDialog.form.sales.englishName || '' }}</el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="responsibilityDialog.stepNo>1" type="primary" @click="previousStep">{{ $t('Invoice.invoice_back') }}</el-button>
        <el-button v-show="responsibilityDialog.stepNo<7" type="primary" @click="nextStep">{{ $t('Invoice.invoice_next') }}</el-button>
        <el-button v-show="responsibilityDialog.stepNo===7" type="primary" @click="doneHandler">{{ $t('CargoMsg.Cargo_Completed') }}</el-button>
        <el-button @click="responsibilityDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { deepCopy } from '@/utils/commonUtil'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { Company } from '@/class/model/mdm/Company'
import { User } from '@/class/model/sys/User'
import { loadAllOperationResponsibility, operationResponsibilityRelatedRoles, saveOperationResponsibility, deleteAllOperationResponsibility } from '@/api/operationResponsibility'
import { loadSpecificBasicInfo } from '@/api/cache'

const AIR_ROUTE = 'AirRoute'
const AIR_COMPANY = 'AirCompany'
const BOOKING_TERM = 'BookingTerm'
const AIR_PORT = 'Airport'
const SALES = 'Sales'

export default {
  name: 'OperationResponsibilityList',
  components: { cargoAdvanceSelect, cargoUserSelect },
  data() {
    return {
      loading: false,
      TYPE_NAMES,
      BookingTerm,
      airRouteList: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
          if (this.selectedNode) {
            const data = this.selectedNode.data
            if (typeof data.airRoute === 'undefined') {
              const criteria = this.getCriteriaByType(data.operationResponsibilityCriteria, AIR_ROUTE)
              let airRoute = null
              if (criteria && criteria.criteriaValue) {
                airRoute = this.airRouteList.find(p => p.code === criteria.criteriaValue)
              }
              data.airRoute = airRoute || {}
            }
            if (typeof data.airCmp === 'undefined') {
              const criteria = this.getCriteriaByType(data.operationResponsibilityCriteria, AIR_COMPANY)
              let cmp = null
              if (criteria && criteria.criteriaValue) {
                cmp = Company.getCompanyByIdSync(Number(criteria.criteriaValue))
              }
              data.airCmp = cmp || {}
            }
            if (typeof data.bookingTerm === 'undefined') {
              const criteria = this.getCriteriaByType(data.operationResponsibilityCriteria, BOOKING_TERM)
              let bookingTerm = null
              if (criteria && criteria.criteriaValue) {
                bookingTerm = BookingTerm.getBookingTypeByCode(criteria.criteriaValue)
              }
              data.bookingTerm = bookingTerm || {}
            }
            if (typeof data.airPort === 'undefined') {
              const criteria = this.getCriteriaByType(data.operationResponsibilityCriteria, AIR_PORT)
              let airPort = null
              if (criteria && criteria.criteriaValue) {
                airPort = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', criteria.criteriaValue)
              }
              data.airPort = airPort || {}
            }
            if (typeof data.sales === 'undefined') {
              const criteria = this.getCriteriaByType(data.operationResponsibilityCriteria, SALES)
              let sales = null
              if (criteria && criteria.criteriaValue) {
                sales = User.getUserByIdSync(Number(criteria.criteriaValue))
              }
              data.sales = sales || {}
            }
            this.form = data
          } else {
            this.form = this.getEmptyForm()
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
          for (const node of event.api.rowModel.rowsToDisplay) {
            node.setDataValue('no', node.rowIndex)
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: 'No',
          colId: 'no',
          width: 60,
          sortable: false,
          valueGetter: params => {
            return params.node.rowIndex + 1
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'name',
          width: 170
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      form: this.getEmptyForm(),
      responsibilityDialog: {
        visible: false,
        title: '',
        form: this.getEmptyForm(),
        stepNo: 1 // 步骤序号
      }
    }
  },
  created() {
    this.queryHandler()
  },
  methods: {
    /**
     * @param {Number} selectedRowKey 选中行key值
     * @param {Number} selectedRowIndex 选中行索引（-1：对应最后一项）
     */
    queryHandler(selectedRowKey = '', selectedRowIndex = 0) {
      this.loading = true
      loadAllOperationResponsibility().then(async res => {
        this.rowData = res.data
        if (this.rowData.length > 0) {
          await loadSpecificBasicInfo('AirRoute').then(res => {
            this.airRouteList = res.data
          })
          if (selectedRowKey) {
            const nodes = this.gridApi.rowModel.rowsToDisplay
            const node = nodes.find(p => p.data.uuid === selectedRowKey)
            if (node) {
              selectedRowIndex = node.rowIndex
            }
          }
          if (selectedRowIndex < 0) {
            selectedRowIndex += this.rowData.length
          }
          this.gridApi.setFocusedCell(selectedRowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getCriteriaByType(operationResponsibilityCriterias, type) {
      return operationResponsibilityCriterias.find(p => p.criteriaType === type) || null
    },
    getEmptyForm() {
      return {
        name: '',
        englishName: '',
        operationResponsibilityCriteria: [],
        airRoute: {},
        airCmp: {},
        bookingTerm: {},
        airPort: {},
        sales: {}
      }
    },
    async addHandler() {
      this.responsibilityDialog.title = this.$t('CargoMsg.Cargo_ResponsibilityNew')
      this.responsibilityDialog.form = this.getEmptyForm()
      this.responsibilityDialog.form.bookingTerm = BookingTerm.SB_BOOKING_TYPE
      this.responsibilityDialog.stepNo = 1
      this.responsibilityDialog.visible = true
      this.loading = true
      loadSpecificBasicInfo('AirRoute').then(res => {
        this.airRouteList = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    editHandler() {
      this.responsibilityDialog.title = this.$t('CargoMsg.Cargo_ResponsibilityEdit')
      this.responsibilityDialog.form = deepCopy(this.selectedNode.data)
      if (!this.responsibilityDialog.form.bookingTerm) {
        this.responsibilityDialog.form.bookingTerm = BookingTerm.SB_BOOKING_TYPE
      }
      this.responsibilityDialog.stepNo = 1
      this.responsibilityDialog.visible = true
      this.loading = true
      loadSpecificBasicInfo('AirRoute').then(res => {
        this.airRouteList = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    previousStep() {
      this.responsibilityDialog.stepNo -= 1
    },
    nextStep() {
      if (this.responsibilityDialog.stepNo === 1) {
        if (!this.responsibilityDialog.form.name.trim()) {
          this.$message.warning(this.$t('AirExport.PleaseEnterAName'))
          return
        }
      }
      this.responsibilityDialog.stepNo += 1
    },
    userLabel(item) {
      if (item) {
        return item.chineseName || item.englishName
      }
      return ''
    },
    doneHandler() {
      const form = this.responsibilityDialog.form
      const criterias = []
      const deletedCriteriaKeys = []
      /* 航线 */
      let criteria = this.getCriteriaByType(form.operationResponsibilityCriteria, AIR_ROUTE)
      if (form.airRoute.code) {
        if (criteria) {
          criteria.criteriaValue = form.airRoute.code
          criterias.push(criteria)
        } else {
          criterias.push({ criteriaType: AIR_ROUTE, criteriaValue: form.airRoute.code })
        }
      } else {
        if (criteria) {
          deletedCriteriaKeys.push(criteria.uuid)
        }
      }
      /* 航空公司 */
      criteria = this.getCriteriaByType(form.operationResponsibilityCriteria, AIR_COMPANY)
      if (form.airCmp.cmpIdx > 0) {
        if (criteria) {
          criteria.criteriaValue = String(form.airCmp.cmpIdx)
          criterias.push(criteria)
        } else {
          criterias.push({ criteriaType: AIR_COMPANY, criteriaValue: String(form.airCmp.cmpIdx) })
        }
      } else {
        if (criteria) {
          deletedCriteriaKeys.push(criteria.uuid)
        }
      }
      /* 订舱性质 */
      criteria = this.getCriteriaByType(form.operationResponsibilityCriteria, BOOKING_TERM)
      if (form.bookingTerm.code) {
        if (criteria) {
          criteria.criteriaValue = form.bookingTerm.code
          criterias.push(criteria)
        } else {
          criterias.push({ criteriaType: BOOKING_TERM, criteriaValue: form.bookingTerm.code })
        }
      } else {
        if (criteria) {
          deletedCriteriaKeys.push(criteria.uuid)
        }
      }
      /* 空港 */
      criteria = this.getCriteriaByType(form.operationResponsibilityCriteria, AIR_PORT)
      if (form.airPort.code) {
        if (criteria) {
          criteria.criteriaValue = form.airPort.code
          criterias.push(criteria)
        } else {
          criterias.push({ criteriaType: AIR_PORT, criteriaValue: form.airPort.code })
        }
      } else {
        if (criteria) {
          deletedCriteriaKeys.push(criteria.uuid)
        }
      }
      /* 销售 */
      criteria = this.getCriteriaByType(form.operationResponsibilityCriteria, SALES)
      if (form.sales.userId > 0) {
        if (criteria) {
          criteria.criteriaValue = String(form.sales.userId)
          criterias.push(criteria)
        } else {
          criterias.push({ criteriaType: SALES, criteriaValue: String(form.sales.userId) })
        }
      } else {
        if (criteria) {
          deletedCriteriaKeys.push(criteria.uuid)
        }
      }
      if (criterias.length === 0) {
        this.$message.warning('航线、航空公司、订舱性质、空港、销售至少录入其中一项！')
        return
      }
      const data = { ...form }
      data.operationResponsibilityCriteria = criterias
      delete data.airRoute
      delete data.airCmp
      delete data.bookingTerm
      delete data.airPort
      delete data.sales
      this.loading = true
      saveOperationResponsibility(data, { deletedCriteriaKeys: deletedCriteriaKeys.join(',') }).then(res => {
        this.queryHandler(data.uuid, data.uuid ? 0 : -1)
        this.responsibilityDialog.visible = false
      }).catch(() => {
        this.loading = false
      })
    },
    async delHandler() {
      this.loading = true
      try {
        const res = await operationResponsibilityRelatedRoles({ operationResponsibilityUuid: this.selectedNode.data.uuid })
        if (res.data && res.data.length > 0) {
          this.$message.warning(this.$t('AirExport.ResponsibilitiesAssignedNoDeletionAllowed'))
          return
        }
      } finally {
        this.loading = false
      }
      this.$confirm(this.$t('AirExport.AreToDeleteThisRecord'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteAllOperationResponsibility({ uuid: this.selectedNode.data.uuid }).then(res => {
          this.queryHandler()
        }).catch(() => {
          this.loading = false
        })
      }).catch()
    }
  }
}
</script>

<style scoped lang="scss">
#app .main-content ::v-deep {
  .el-loading-mask {
    z-index: 999999;
  }
}
.responsibility-dialog ::v-deep {
  .el-dialog__body {
    padding: 0;
  }
}
.step {
  height: 300px;
}
.step-title {
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: #c0c0c0;
  font-size: 16px;
}
</style>
